/*
* FUNCTION DECLARATIONS
*/

export function integerArithmetic(data) {
  return {
    type: 'INTEGER_ARITHMETIC',
    returnType: 'INTEGER',
    name: 'Integer Arithmetic',
    description: '{arg0:1} {arg1:+} {arg2:1}',
    argTypes:['INTEGER','INTEGER_ARITHMETIC_OPERATOR','INTEGER'],
    defaultArgs:[
      {mode:'VALUE', value:'1'},
      {mode:'PREDEF', value: 'INTEGER_ARITHMETIC_OPERATOR_PLUS'},
      {mode:'VALUE', value:'1'},
      ],
  }
}

export function booleanToInteger(data) {
  return {
    type: 'BOOLEAN_TO_INTEGER',
    returnType: 'INTEGER',
    name: 'Boolean to integer',
    description: '{arg0:1}',
    argTypes:['BOOLEAN'],
    defaultArgs:[
      {mode:'VALUE', value:'1'},
      ],
  }
}

export function integerToString() {
  return {
    type: 'INTEGER_TO_STRING',
    returnType: 'STRING',
    name: 'Integer To String',
    description: 'Integer To String: {arg0:1}',
    argTypes:['INTEGER'],
    defaultArgs:[
      {mode:'VALUE', value:'1'},
      ],
  }
}

export function integerToBoolean() {
  return {
    type: 'INTEGER_TO_BOOLEAN',
    returnType: 'BOOLEAN',
    name: 'Integer To Boolean',
    description: 'Integer To Boolean: {arg0:1}',
    argTypes:['INTEGER'],
    defaultArgs:[
      {mode:'VALUE', value:'1'},
      ],
  }
}

export function notBoolean() {
  return {
    type: 'NOT_BOOLEAN',
    returnType: 'BOOLEAN',
    name: 'Not Boolean',
    description: 'Inverted Boolean: {arg0:1}',
    argTypes:['BOOLEAN'],
    defaultArgs:[
      {mode:'VALUE', value:'1'},
      ],
  }
}

export function concate2Strings() {
  return {
    type: 'STRING_CONCAT',
    returnType: 'STRING',
    name: 'Concat Two Strings',
    description: '{arg0:str} + {arg1:str}',
    argTypes:['STRING', 'STRING'],
    defaultArgs:[
      {mode:'VALUE', value:''},
      {mode:'VALUE', value:''},
      ],
  }
}

export function assignateOutput() {
  return {
    type: 'ASSIGNATE_OUTPUT',
    returnType: 'ASSIGNABLE_INTEGER',
    name: 'Set ouput',
    description: 'Set {arg0:output}',
    argTypes:['PIN_OUTPUT'],
  }
}

export function localizedSound() {
  return {
    type: 'LOCALIZED_SFX',
    returnType: 'SFX',
    name: 'Localized Sound',
    description: 'Fr:{arg0:sound0} - En:{arg1:sound1}',
    argTypes:['SFX', 'SFX'],
  }
}


/*
export function languageUpdate(newLanguage) {
  return {
    type: 'LANGUAGE_UPDATE',
    newLanguage,
    meta: {
    	pad:true,
    	pod:true,
    },
  }
}

export function languageUpdate(newLanguage) {
  return {
    type: 'LANGUAGE_UPDATE',
    newLanguage,
    meta: {
    	pad:true,
    	pod:true,
    },
  }
}
*/